import { createSelector } from "reselect";

import { RootState } from "../../../redux/store";
import Store from "../../../redux/store";

import { IAppSearchState, ISearchParams } from "../types/app-search.types";

import * as actions from "./app-search.actions";

export const getAppSearchState = (state: RootState): IAppSearchState => state.appSearch;

export const getErrors = createSelector(
  getAppSearchState,
  (state: IAppSearchState) => state.errors
);

export const getPagination = createSelector(
  getAppSearchState,
  (state: IAppSearchState) => state.pagination
);

export const getResults = createSelector(
  getAppSearchState,
  (state: IAppSearchState) => state.results
);

export const isLoaded = createSelector(getAppSearchState, (state: IAppSearchState) => state.loaded);

export const isLoading = createSelector(
  getAppSearchState,
  (state: IAppSearchState) => state.loading
);

export function clear() {
  Store.dispatch(actions.clearSearch());
}

export function search(endpoint: string, dataKey: string, params: ISearchParams) {
  Store.dispatch(actions.searchApp(endpoint, dataKey, params));
}
